import {
	selectBookingThreadMod,
	selectOrderBookingData,
	selectOrderDetail,
	setBookingThreadMod,
	updateBookingDate,
} from 'entities/orders';
import {
	BookingTime,
	selectActiveBookingTime,
	selectBookingTimes,
	selectDisableBookingTime,
	selectSelectedTimeslot,
} from 'entities/toolbar/timeslots';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { useBookingSlots } from './useBookingSlots';
import { getResourcesFree } from 'entities/hallmap';
import { formatTime } from 'shared/lib/time';

export const useSlots = () => {
	const bookingTimes = useAppSelector(selectBookingTimes);
	const order = useAppSelector(selectOrderDetail);
	const activeBookingTime = useAppSelector(selectActiveBookingTime);
	const disabledBookingTime = useAppSelector(selectDisableBookingTime);
	const { setCurrentActive, currentActive } = useBookingSlots();
	const dispatch = useAppDispatch();
	const [bookingStreamModWasUsed, setUseBookingStreamMod] = useState(false);
	const bookingStreamMod = useAppSelector(selectBookingThreadMod);
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
	const bookingData = useAppSelector(selectOrderBookingData);

	const prevActiveBookingTimeRef = useRef<BookingTime | null>(null);
	const isTouched = useRef<boolean>(false);

	const updateBookingDataAndChangeSlot = useCallback(
		(bookingTime: BookingTime) => {
			dispatch(updateBookingDate({ date: bookingTime.date }));
		},
		[dispatch],
	);

	const setResourcesByBookingTime = useCallback(
		(
			bookingTime: BookingTime,
			updateDateOfBooking: boolean = false,
			resetCurrentActive = false,
		) => {
			//TODO попросить исправить на бэкенде букинг слоты должны приходить в соответствии с переданной
			//длительностью сейчас какую длительность мы бы не передали всегда придет 150 как только исправить убрать
			//если так и нужно то тогда оставить как есть
			bookingTime = { ...bookingTime, duration: bookingData.duration };
			if (bookingTime) {
				if (updateDateOfBooking) {
					updateBookingDataAndChangeSlot(bookingTime);
				}

				let time = bookingTime.time;
				if (resetCurrentActive) {
					time = '';
				}

				setCurrentActive(time);

				if (bookingStreamModWasUsed) {
					if (selectedTimeslot === bookingTime.date) {
						dispatch(setBookingThreadMod({ isWork: true }));
					} else {
						dispatch(setBookingThreadMod({ isWork: false }));
					}
				}
			}
		},
		[
			bookingStreamModWasUsed,
			selectedTimeslot,
			bookingData,
			dispatch,
			setCurrentActive,
			updateBookingDataAndChangeSlot,
		],
	);

	const activeSlot = (bookingTime: BookingTime) => {
    isTouched.current = true;

		dispatch(
			getResourcesFree({
				dt_requested_start: bookingTime.date,
				duration: bookingData.duration,
				exclude_appointment: order?.appointment?.id || undefined
			}),
		);

		if (bookingTime.time !== disabledBookingTime?.time) {
			setResourcesByBookingTime(bookingTime, true);
		} else {
			setResourcesByBookingTime(bookingTime, true, !bookingData?.id);
		}
	};

	useEffect(() => {
		if (
			disabledBookingTime &&
			disabledBookingTime !== prevActiveBookingTimeRef.current
		) {
			const findedTime = bookingTimes.find(item => item.time === currentActive);
			
			if (findedTime) {
				dispatch(updateBookingDate({ date: findedTime.date }));

				return;
			}

			setResourcesByBookingTime(
				disabledBookingTime,
				false,
				!bookingData?.id,
			);
			prevActiveBookingTimeRef.current = disabledBookingTime;
		}
		// eslint-disable-next-line
	}, [disabledBookingTime, setResourcesByBookingTime]);

	useEffect(() => {
    // console.log(
    //   'activeBookingTime', 
    //   activeBookingTime,
    //   activeBookingTime !== prevActiveBookingTimeRef.current, 
    //   activeBookingTime?.date, 
    //   prevActiveBookingTimeRef.current?.date
    // )
    if (!activeBookingTime) {
      const time = formatTime({time:bookingData.dt_start})
      if (time) {
        setCurrentActive(time.time);
      }
    }

		if (
			activeBookingTime &&
			activeBookingTime !== prevActiveBookingTimeRef.current
		) {
			const findedTime = bookingTimes.find(item => item.time === currentActive);

			if (findedTime) {
        if (isTouched.current) {
          setResourcesByBookingTime(activeBookingTime);
          prevActiveBookingTimeRef.current = activeBookingTime;

          return;
        } else {
          // dispatch(updateBookingDate({ date: findedTime.date }));
          return;
        }
			}

			setResourcesByBookingTime(activeBookingTime);
			prevActiveBookingTimeRef.current = activeBookingTime;
		}
		// eslint-disable-next-line
	}, [bookingData, activeBookingTime, setResourcesByBookingTime]);

	useEffect(() => {
		if (bookingStreamMod) {
			setUseBookingStreamMod(true);
		}
	}, [bookingStreamMod]);

	return {
		bookingTimes,
		currentActive,
		disabledBookingTime,
		activeSlot,
		activeBookingTime,
	};
};
